import React, { useState } from 'react';
import {
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalTitle,
    CloseButton,
} from '../../styles/CreateWorkspaceModal.styles';
import WorkspaceForm from './WorkspaceForm';

const EditWorkspaceModal = ({ workspace, onClose, onUpdate }) => {
    const [formData, setFormData] = useState({
        name: workspace.name,
        description: workspace.description
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [id]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await onUpdate(formData);
            onClose();
        } catch (error) {
            console.error('Error updating workspace:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <ModalOverlay onClick={handleOverlayClick}>
            <ModalContent onClick={e => e.stopPropagation()}>
                <ModalHeader>
                    <ModalTitle>Edit Workspace</ModalTitle>
                    <CloseButton onClick={onClose}>&times;</CloseButton>
                </ModalHeader>

                <WorkspaceForm
                    name={formData.name}
                    description={formData.description}
                    loading={loading}
                    onNameChange={handleChange}
                    onDescriptionChange={handleChange}
                    onSubmit={handleSubmit}
                    onClose={onClose}
                    isEdit={true}
                />
            </ModalContent>
        </ModalOverlay>
    );
};

export default EditWorkspaceModal;